import React from "react";
import { Modal } from "react-bootstrap";
import { motion } from "framer-motion";
import Batuk2 from "../assets/images/new/fav-removebg-preview.png";

const ComingSoonModal = ({ show, onClose, moduleName }) => {
  const handleClose = () => {
    onClose(false);
  };

  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      centered
      dialogClassName="custom-modal-width"
    >
      <Modal.Header closeButton onClick={handleClose} />
      <Modal.Body>
        <motion.img
          src={Batuk2}
          alt="Coming Soon"
          className="mb-3"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        />
        {moduleName === 'e-webinar' ? (
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.5 }}
          >
            Thank you for subscribing to the <br />  Myomnamo Webinar 2025!
          </motion.p>

        ) : moduleName === 'm-webinar' ? (
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.5 }}
          >
            सदस्यता घेतल्याबद्दल धन्यवाद <br /> माय ओम नमो वेबिनार 2025!
          </motion.p>

        ) : <>
          <motion.h3
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            Coming Soon!
          </motion.h3>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.5 }}
          >
            Thank You.
          </motion.p>
        </>}

      </Modal.Body>
    </Modal>
  );
};

export default ComingSoonModal;
